import { useContext } from 'react'

import { AddActionDialog } from '@pages/EntityCreateOrEdit'
import { PageContext } from '@pages/TimeLineCreateOrEdit/TimeLineCreateOrEdit'

import { CATEGORIES, ENTITY_TYPES_REQUEST } from '@constants'
import { ActionRow } from '@types'

export const GeneralAddActionDialog = () => {
  const { handlers, state } = useContext(PageContext)

  const { handleSaveTimeLine, handleCloseGeneralAddActionDialog, handleChangeGeneralAction } =
    handlers

  const {
    generalAddActionDialogData,
    generalShowAddActionDialog,
    watchId,
    isCreateOrUpdateLoading,
  } = state

  const handleCreateAction = (data: ActionRow) => {
    handleChangeGeneralAction(data)

    return handleSaveTimeLine()
  }

  const handleEditAction = (data: ActionRow) => {
    handleChangeGeneralAction(data)

    return handleSaveTimeLine()
  }

  if (!generalAddActionDialogData) {
    return null
  }

  return (
    <AddActionDialog
      actionEventsCategoryCode={CATEGORIES.BINDING_TIME_TABLE_EVENTS_ACTION}
      actionTable={generalAddActionDialogData.actionTable}
      bindingValuesAction={generalAddActionDialogData.bindingValuesAction}
      columns={[]}
      createAction={handleCreateAction}
      currentRow={generalAddActionDialogData.currentRow}
      editAction={handleEditAction}
      isActionLoading={isCreateOrUpdateLoading}
      modalType={generalAddActionDialogData.modalType}
      objectCode={generalAddActionDialogData.objectCode}
      showDialog={generalShowAddActionDialog}
      variablesConfig={{
        entityType: ENTITY_TYPES_REQUEST.TIME_TABLE,
        entityId: watchId,
      }}
      onCloseModal={handleCloseGeneralAddActionDialog}
    />
  )
}
